<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
import { setUserName, setOsType } from './utils/cookie'

export default {
  name: 'App',
  created () {
    let userName = decodeURIComponent(this.getQueryString('user_name'))
    let osType = decodeURIComponent(this.getQueryString('os_type'))
    if (userName !== '') {
      setUserName(userName)
    }
    if (osType !== '') {
      setOsType(osType)
    } else {
      setOsType(0)
    }
  },
  mounted () {
  },
  methods: {
    // 获取参数
    getQueryString (variable) {
      let query = window.location.search.substring(1)
      let vars = []
      if (query === '') {
        vars = window.location.href.split('?')
      } else {
        vars = query.split('&')
      }
      for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (pair[0] === variable) {
          return pair[1]
        }
      }
      return ''
    }
  }
}
</script>

<style>
    /*@import "./assets/mixin.scss";*/
    @import "./assets/common/css/reset.scss";
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue